import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Card, Form, Button,Row,Col } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { alertErrorMessage, alertSuccessMessage, confirmDelete } from "../../components/alert";



export default function AddQuestions() {
  const { examId } = useParams();
  const navigate = useNavigate();
  const [exam, setExam] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [questionTypes, setQuestionTypes] = useState([]);
  const [selectedType, setSelectedType] = useState(null);

  const examPaperId = Number(examId);



  // ✅ Fetch exam + questions
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!examId) return;

    axios
      .post(
        "https://codydealms.codydeasoftech.in/api/teacher/fetchExamPaperQuestions",
        { exam_paper_id: examId },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((res) => {
        if (res.data?.status && res.data?.data?.exam_paper) {
          const examData = res.data.data.exam_paper;
          setExam(examData);

          const apiQuestions = res.data.data.questions || [];
          let initialQuestions = [];

          if (apiQuestions.length > 0) {
            initialQuestions = apiQuestions.map((q) => ({
              id: q.id,
              type: q.question_type, // 👈 store type
              text: q.question_type === 2 ? "" : q.question,
              options:
                q.question_type === 2
                  ? ["", "", "", ""]
                  : [q.optionA, q.optionB, q.optionC, q.optionD],
              correctIndex:
                q.question_type === 2
                  ? null
                  : ["A", "B", "C", "D"].indexOf(q.answer),
              file: q.question_type === 2 ? q.question : null, // url or file
            }));
          } else {
            initialQuestions = Array.from(
              { length: examData.number_of_questions },
              () => ({
                id: 0,
                type: selectedType || 1,
                text: "",
                options: ["", "", "", ""],
                correctIndex: null,
                file: null,
              })
            );
          }

          setQuestions(initialQuestions);
        }
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          localStorage.removeItem("token");
          navigate("/login");
        } else {
          console.error(err);
        }
      });
  }, [examId, navigate, selectedType]);

  // ✅ Fetch question types
  useEffect(() => {
    const token = localStorage.getItem("token");
    axios
      .get(
        "https://codydealms.codydeasoftech.in/api/teacher/fetchExamPaperQuestionsTypes",
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((res) => {
        if (res.data?.status) {
          setQuestionTypes(res.data.data.exam_papers_questions_types);
          setSelectedType(res.data.data.exam_papers_questions_types[0]?.id || null);
        }
      })
      .catch((err) => console.error(err));
  }, []);

  // --- Helpers ---
  const updateQuestion = (qIndex, value) => {
    const updated = [...questions];
    updated[qIndex].text = value;
    setQuestions(updated);
  };

  const updateOption = (qIndex, oIndex, value) => {
    const updated = [...questions];
    updated[qIndex].options[oIndex] = value;
    setQuestions(updated);
  };

  const selectCorrectOption = (qIndex, oIndex) => {
    const updated = [...questions];
    updated[qIndex].correctIndex = oIndex;
    setQuestions(updated);
  };

  const updateFile = (qIndex, file) => {
    const updated = [...questions];
    updated[qIndex].file = file;
    setQuestions(updated);
  };


const handleSubmit = async () => {
  const token = localStorage.getItem("token");
  console.log("🔑 Token:", token);
  console.log("📄 Exam Paper ID:", examPaperId);
  console.log("📝 All Questions State:", questions);

  try {
    // --- Text Questions ---
    const textQuestions = questions.filter((q) => q.type === 1);
    console.log("📝 Text Questions Found:", textQuestions);

    if (textQuestions.length > 0) {
      const payload = new URLSearchParams();
      payload.append("exam_paper", examPaperId);
      payload.append("question_type", 1);

      textQuestions.forEach((q, index) => {
        payload.append(`questions[${index}]`, q.text || "");
        payload.append(`optionA[${index}]`, q.options?.[0] || "");
        payload.append(`optionB[${index}]`, q.options?.[1] || "");
        payload.append(`optionC[${index}]`, q.options?.[2] || "");
        payload.append(`optionD[${index}]`, q.options?.[3] || "");
        payload.append(
          `answers[${index}]`,
          ["A", "B", "C", "D"][q.correctIndex] || "A"
        );
        payload.append(`marks[${index}]`, exam.marks_of_each || 0);

        if (q.id) payload.append(`ids[${index}]`, q.id);

        console.log(`➡️ Text Question [${index}] Payload:`, {
          question: q.text || "",
          optionA: q.options?.[0] || "",
          optionB: q.options?.[1] || "",
          optionC: q.options?.[2] || "",
          optionD: q.options?.[3] || "",
          answer: ["A", "B", "C", "D"][q.correctIndex] || "A",
          marks: exam.marks_of_each || 0,
          id: q.id || "new",
        });
      });

      console.log("📦 Final Text Payload:", payload.toString());

      const resText = await axios.post(
        "https://codydealms.codydeasoftech.in/api/teacher/addEditExamPaperQuestions",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );

      console.log("✅ Text Questions API Response:", resText.data);
    }

    // --- File Questions ---
    const fileQuestions = questions.filter((q) => q.type === 2);
    console.log("📂 File Questions Found:", fileQuestions);

    if (fileQuestions.length > 0) {
      const formData = new FormData();
      formData.append("exam_paper", examPaperId);
      formData.append("question_type", 2);

      fileQuestions.forEach((q, index) => {
        formData.append(`questions[${index}]`, q.text || "File Question");
        formData.append(`optionA[${index}]`, q.options?.[0] || "");
        formData.append(`optionB[${index}]`, q.options?.[1] || "");
        formData.append(`optionC[${index}]`, q.options?.[2] || "");
        formData.append(`optionD[${index}]`, q.options?.[3] || "");
        formData.append(`answers[${index}]`, "");
        formData.append(`marks[${index}]`, exam.marks_of_each || 0);

        if (q.id) formData.append(`ids[${index}]`, q.id);

        if (q.file) {
          formData.append(`question_files[${index}]`, q.file);
          console.log(`📎 File Attached for Question [${index}]:`, q.file.name);
        } else {
          console.warn(`⚠️ No File Found for Question [${index}]`);
        }
      });

      for (let pair of formData.entries()) {
        console.log(`📦 FormData Entry -> ${pair[0]}:`, pair[1]);
      }

      const resFile = await axios.post(
        "https://codydealms.codydeasoftech.in/api/teacher/addEditExamPaperQuestions",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("✅ File Questions API Response:", resFile.data);
    }

    // ✅ SweetAlert success
    // await Swal.fire({
    //   icon: "success",
    //   title: "Questions submitted successfully!",
    //   showConfirmButton: true,
    // });

    await alertSuccessMessage("Questions submitted successfully!")



    navigate("/exam-paper");
  } catch (error) {
    console.error("❌ Error submitting questions:", error.response || error);

    // ✅ SweetAlert error
    // await Swal.fire({
    //   icon: "error",
    //   title: "Failed to submit questions",
    //   text: "Please try again.",
    //   showConfirmButton: true,
    // });

    await alertErrorMessage("Failed to submit questions")
  }
};







  if (!exam) return <p>Loading exam details...</p>;

  return (
    <Card className="shadow-lg rounded-4 border-0 p-4" style={{ backgroundColor: "#ffffff",maxWidth: "1462px" }}>
      <Card.Body>
        {/* Exam Header */}
        <div className="mb-4">
          <h3 style={{ color: "#5856d6" }}>{exam.title}</h3>
          <p className="text-muted">
            {exam.exam_master_name} • {exam.department_name}
          </p>
           <div className="text-muted pb-3">
            <b>Paper Code</b> {exam.paper_code}
           </div>
          {/* <div className="d-flex gap-3 flex-wrap">
            <span className="badge bg-success fw-bold fs-6">
              Questions: {exam.number_of_questions}
            </span>
            <span className="badge bg-success fw-bold fs-6">
              Marks/Question: {exam.marks_of_each}
            </span>
            <span className="badge bg-success fw-bold fs-6">
              Total Marks: {exam.total_marks}
            </span>
          </div> */}
          <div className="d-flex align-items-center flex-wrap gap-3 mb-4">
  <span className="badge bg-success fw-bold fs-6">
    Questions: {exam.number_of_questions}
  </span>
  <span className="badge bg-success fw-bold fs-6">
    Marks/Question: {exam.marks_of_each}
  </span>
  <span className="badge bg-success fw-bold fs-6">
    Total Marks: {exam.total_marks}
  </span>

  {/* Question Type Dropdown */}
    <div className="d-flex align-items-center">
      <Form.Label className="fw-bold me-2 mb-0">Question Type</Form.Label>
<Form.Select
  value={selectedType || ""}
  onChange={(e) => setSelectedType(Number(e.target.value))}
  className="shadow-sm rounded-2"
  style={{ minWidth: "200px", width: "auto" }}  // 👈 wider dropdown
>
  {questionTypes.map((t) => (
    <option key={t.id} value={t.id}>
      {t.name}
    </option>
  ))}
</Form.Select>
    </div>

</div>

        </div>

        

        {/* Questions Loop */}
        {questions.map((q, qIndex) => (
          <Card
            key={`${exam.id}-q-${qIndex}`}
            className="mb-4 shadow rounded-3"
            style={{ backgroundColor: "#e7e6e3", border: "2px solid #D8B4FE" }}
          >
            <Card.Header style={{ backgroundColor: "#5856d6", color: "#fff", fontWeight: "bold" }}>
              Question {qIndex + 1}
            </Card.Header>

            <Card.Body>
              {/* <div className="d-flex justify-content-end mb-3">
                <small className="text-muted">{`${qIndex + 1}/${questions.length}`}</small>
              </div> */}

              <div className="p-2">
                {q.type === 1 && (
                <>
                  {/* Text Question */}
                  <Form.Control
                    type="text"
                    placeholder="Enter question"
                    value={q.text}
                    onChange={(e) => updateQuestion(qIndex, e.target.value)}
                    className="mb-3 shadow-sm rounded-2"
                  />

                  {/* Options */}
                 {/* <div className="d-flex flex-wrap gap-2 mb-1 pt-4">
                    {q.options.map((opt, oIndex) => (
                      <Form.Check
                        key={`${exam.id}-q-${qIndex}-o-${oIndex}`}
                        type="radio"
                        name={`question-${exam.id}-${qIndex}`}
                        checked={q.correctIndex === oIndex}
                        onChange={() => selectCorrectOption(qIndex, oIndex)}
                        className="flex-grow-1"
                        label={
                          <Form.Control
                            type="text"
                            placeholder={`Option ${oIndex + 1}`}
                            value={opt}
                            onChange={(e) => updateOption(qIndex, oIndex, e.target.value)}
                            className="shadow-sm rounded-2"
                          />
                        }
                      />
                    ))}
                  </div> */}
                                      {/* <div className="text-start fw-bold">Answers.</div> */}


                  <div className="d-flex flex-wrap gap-2 mb-1 pt-4">

  {q.options.map((opt, oIndex) => (
    <div
      key={`${exam.id}-q-${qIndex}-o-${oIndex}`}
      className="d-flex align-items-center flex-grow-1"
    >
      <Form.Check
        type="radio"
        name={`question-${exam.id}-${qIndex}`}
        checked={q.correctIndex === oIndex}
        onChange={() => selectCorrectOption(qIndex, oIndex)}
        className="me-2 mb-0" // remove bottom margin
      />
      <Form.Control
        type="text"
        placeholder={`Option ${oIndex + 1}`}
        value={opt}
        onChange={(e) => updateOption(qIndex, oIndex, e.target.value)}
        className="shadow-sm rounded-2"
      />
    </div>
  ))}
</div>





                </>
              )}

              {q.type === 2 && (
                <div className="mb-3">
                  <Form.Label>Upload File</Form.Label>
                  <Form.Control
                    type="file"
                    onChange={(e) => updateFile(qIndex, e.target.files[0])}
                  />
                  {q.file && typeof q.file === "string" && (
                    <a
                      href={q.file}
                      target="_blank"
                      rel="noreferrer"
                      className="d-block mt-2 text-primary"
                    >
                      View Existing File
                    </a>
                  )}
                </div>
              )}
              </div>
            </Card.Body>
          </Card>
        ))}

        {/* Submit Button */}
        <div className="d-flex justify-content-center mt-3">
          {/* <Button
            onClick={handleSubmit}
            className="px-5 py-2 fw-bold"
            style={{
              backgroundColor: "#5856d6",
              border: "none",
              borderRadius: "12px",
              color: "#fff",
              boxShadow: "0 4px 12px rgba(88, 86, 214, 0.3)",
            }}
          >
            Submit All Questions
          </Button> */}

          <Button
  onClick={handleSubmit}
  className="px-5 py-2 fw-bold"
  style={{
    backgroundColor: "#5856d6",
    border: "none",
    borderRadius: "12px",
    color: "#fff",
    boxShadow: "0 4px 12px rgba(88, 86, 214, 0.3)",
  }}
>
  {questions.length === 0 || questions.every(q => q.id === 0) ? "Save Questions" : "Update Questions"}
</Button>

        </div>
      </Card.Body>
    </Card>
  );
}
